// action - account reducer
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const REFRESH = "REFRESH";
export const UPDATE = "UPDATE";
export const FIREBASE_STATE_CHANGED = "FIREBASE_STATE_CHANGED";
